import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

interface MobilePhoneFrameProps {
  children: ReactNode
  title?: string
}

export const MobilePhoneFrame = ({
  children,
  title = '📱 Mobile Preview',
}: MobilePhoneFrameProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '375px',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          padding: '16px',
          backgroundColor: '#f5f5f5',
          borderRadius: '12px',
          border: '2px solid #ddd',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
          <Typography variant='subtitle2' sx={{ color: 'text.secondary', fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>

        <Box
          sx={{
            width: '100%',
            height: '667px',
            backgroundColor: '#000',
            borderRadius: '48px',
            padding: '8px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              backgroundColor: '#fff',
              borderRadius: '42px',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                height: '54px',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                position: 'relative',
                flexShrink: 0,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  fontSize: '15px',
                  fontWeight: 600,
                  color: '#000',
                  flex: 1,
                  textAlign: 'center',
                }}
              >
                {new Date().toLocaleTimeString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
                })}
              </Typography>
              <Box
                sx={{
                  width: '115px',
                  height: '27px',
                  backgroundColor: '#000',
                  borderRadius: '20px',
                  flex: 1,
                }}
              />

              <Box
                sx={{
                  display: 'flex',
                  gap: '5px',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: 1,
                }}
              >
                <Box sx={{ display: 'flex', gap: '1.5px', alignItems: 'flex-end', height: '12px' }}>
                  {[4, 6, 8, 10].map((height, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        width: '3px',
                        height: `${height}px`,
                        backgroundColor: '#000',
                        borderRadius: '1px',
                      }}
                    />
                  ))}
                </Box>

                <Box sx={{ width: '15px', height: '12px', display: 'flex' }}>
                  <svg width='15' height='12' viewBox='0 0 15 12' fill='none'>
                    <path
                      d='M7.5 12C8.05 12 8.5 11.55 8.5 11C8.5 10.45 8.05 10 7.5 10C6.95 10 6.5 10.45 6.5 11C6.5 11.55 6.95 12 7.5 12Z'
                      fill='#000'
                    />
                    <path
                      d='M7.5 8C8.88 8 10.16 8.54 11.12 9.42L12.18 8.36C10.92 7.22 9.28 6.5 7.5 6.5C5.72 6.5 4.08 7.22 2.82 8.36L3.88 9.42C4.84 8.54 6.12 8 7.5 8Z'
                      fill='#000'
                    />
                    <path
                      d='M7.5 4.5C9.76 4.5 11.84 5.38 13.42 6.86L14.48 5.8C12.6 4.02 10.16 3 7.5 3C4.84 3 2.4 4.02 0.52 5.8L1.58 6.86C3.16 5.38 5.24 4.5 7.5 4.5Z'
                      fill='#000'
                    />
                  </svg>
                </Box>

                <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: '22px',
                      height: '12px',
                      border: '1.5px solid #000',
                      borderRadius: '2.5px',
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      padding: '1.5px',
                    }}
                  >
                    <Box
                      sx={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: '#000',
                        borderRadius: '1px',
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: '1.5px',
                      height: '4px',
                      backgroundColor: '#000',
                      borderRadius: '0 1px 1px 0',
                      ml: '0.5px',
                    }}
                  />
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                flex: 1,
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              {children}
            </Box>

            <Box
              sx={{
                height: '34px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <Box
                sx={{
                  width: '134px',
                  height: '5px',
                  backgroundColor: '#000',
                  borderRadius: '3px',
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
